import { InputNumber, InputNumberProps } from 'antd';
import FormField from 'components/FormField';
import { DisabledProps, FV, IsPolicyProps } from './share';
import { Inline } from './TimeoutReplyField';
import { T, useTranslate } from '@tolgee/react';

function X(props: InputNumberProps<number>) {
  const { children, ...others } = props;

  return <InputNumber min={1} max={288} precision={0} {...others} />;
}

function WelcomeReplyField(props: DisabledProps & IsPolicyProps) {
  const { disabled = false, isPolicy = false } = props;

  const { t } = useTranslate();

  return (
    <FormField<FV['welcomeReplyTaskConfig']['coolDownHour']>
      name={
        isPolicy
          ? 'scenarioConfig.welcomeReplyTaskConfig.coolDownHour'
          : 'welcomeReplyTaskConfig.coolDownHour'
      }
      label={t('aide.冷却时间')}
      validate={(value) => (value ? undefined : t('department.请输入x', { x: t('aide.冷却时间') }))}
    >
      {({ field }) => {
        return (
          <Inline>
            <T
              keyName="aide.同一买家在x小时内只会触发一次进店欢迎语"
              params={{
                x: <X disabled={disabled} {...field} />,
              }}
            />
          </Inline>
        );
      }}
    </FormField>
  );
}

export default WelcomeReplyField;
